import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import { ApolloProvider } from '@apollo/client';
import Home from './pages/home/Home';
import Login from './pages/login/Login';
import Card from './pages/card/Card';
import createApolloClient from './service/apolloClient';
import store from './redux/store'
import { Provider } from 'react-redux'
import RequireAuth from './components/RequireAuth'
import Redirect from './pages/redirect/Redirect';

function App() {
  const client = createApolloClient()

  return (
    <div className="App">
      <BrowserRouter>
        <ApolloProvider client={client}>
          <Provider store={store}>
            <Routes>
              {/* Public routes */}
              <Route path='/' element={<Login />} />
              <Route path='/:personId' element={<Card />} />
              <Route path='/redirect' element={<Redirect />} />

              {/* Private routes */}
              <Route path='/home' element={<RequireAuth><Home /></RequireAuth>} />
            </Routes>
          </Provider>
        </ApolloProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
